import React from 'react'
import classnames from 'classnames'
import { Button } from 'antd'
import { LeftOutlined } from '@ant-design/icons'
import { AppState } from '../../stores/app'
import { Container } from 'typescript-ioc/es5'
import { observer } from 'mobx-react'
import { useUserPreferences } from '@pushly/aqe/lib/providers/user-preferences-provider/core/index'

const SidebarCollapseToggle: React.FC = observer(() => {
    const appState = Container.get(AppState)
    const userPreferences = useUserPreferences(appState.currentUser?.id)
    const sidebarExpanded = userPreferences.get(['sidebar_expanded'])

    const toggleSidebar = () => {
        userPreferences.set(['sidebar_expanded'], !sidebarExpanded)
    }

    return (
        <div
            className={classnames('sidebar-toggle', {
                open: sidebarExpanded,
                collapsed: !sidebarExpanded,
            })}
            onClick={toggleSidebar}
        >
            <Button className={classnames('sidebar-toggle-btn')} size="small" shape="circle" icon={<LeftOutlined />} />
        </div>
    )
})

export default SidebarCollapseToggle
